import type { SliderDefaultSettings } from './defaultSettings';

interface mapSliderDefaultSettings extends SliderDefaultSettings {
  carouselArrowBackgroundColor: string;
  carouselArrowColor: string;
  carouselArrowBackgroundColorOnHover: string;
  carouselArrowColorOnHover: string;
  carouselArrowSize: number;
  carouselPaginationColor: string;
}

export const mapSliderLayoutSettings = (settings: mapSliderDefaultSettings) => {
  const {
    sliderAutoplay,
    sliderAutoplayPauseOnHover,
    sliderAutoplayInterval,
    sliderAnimationType,
    sliderAnimationSpeed,
    sliderPagination,
    sliderArrowsEnable,
    sliderArrowsShowOnHover,
    sliderArrowsOnMobileEnable,
    sliderSwipeDesktopEnable,
    sliderSwipeMobileEnable,
    sliderRtl,
    limitTotalNumberOfItems,
    totalNumberOfItems,

    carouselArrowBackgroundColor,
    carouselArrowColor,
    carouselArrowBackgroundColorOnHover,
    carouselArrowColorOnHover,
    carouselArrowSize,
    carouselPaginationColor
  } = settings;

  return {
    autoplay: sliderAutoplay,
    autoplayPauseOnHover: sliderAutoplayPauseOnHover,
    autoplayInterval: sliderAutoplayInterval,
    animationType: sliderAnimationType,
    animationSpeed: sliderAnimationSpeed,
    pagination: sliderPagination,
    arrowsEnable: sliderArrowsEnable,
    arrowsOnMobileEnable: sliderArrowsOnMobileEnable,
    arrowsShowOnHover: sliderArrowsShowOnHover,
    swipeDesktopEnable: sliderSwipeDesktopEnable,
    swipeMobileEnable: sliderSwipeMobileEnable,
    rtl: sliderRtl,
    limitTotalNumberOfItems,
    totalNumberOfItems,

    arrowBackgroundColor: carouselArrowBackgroundColor,
    arrowColor: carouselArrowColor,
    arrowBackgroundColorOnHover: carouselArrowBackgroundColorOnHover,
    arrowColorOnHover: carouselArrowColorOnHover,
    arrowSize: carouselArrowSize,
    paginationColor: carouselPaginationColor
  };
};
